export default function getResource(label, vars = []) {
    const resources = {
        tabRewards: 'Récompenses',
        tabEarnPoints: 'Accumulez des points',
        tabBenefits: 'Bienfaits',
        tabHistory: 'Historique'
    };
    return resources[label];
}
